export default {
  views: {
    invalidUrl: 'URL 無效。',
    successToResetPassword: '密碼已成功重設。',
    resetPassword: '重設密碼',
    send: '送出',
    resetError: '密碼重設連結已過期，或密碼已經重設。',
    passwordRules: {
      title: '注意：密碼規則',
      tips1: '請建立至少 8 個字元，包含字母與數字的密碼。'
    },
    enrollOTP: {
      title: '註冊雙重驗證',
      code: '驗證碼',
      verify: '驗證'
    }
  }
};
